/**
 * 代理推广请求接口
 * @author 王振宇
 * @since 2022-07-07
 */
export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request,
    serviceForMock = _ref.serviceForMock,
    requestForMock = _ref.requestForMock,
    mock = _ref.mock,
    faker = _ref.faker,
    tools = _ref.tools;
  return {
    GET_AGENCYPROMOTION_PAGE_LIST: function GET_AGENCYPROMOTION_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/agencyPromotion/getPageList',
        method: 'post',
        data: data
      });
    },
    GET_AGENCYPROMOTION_LIST: function GET_AGENCYPROMOTION_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/agencyPromotion/getList',
        method: 'get',
        params: data
      });
    },
    GET_AGENCYPROMOTION_INFO: function GET_AGENCYPROMOTION_INFO() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/agencyPromotion/info',
        method: 'get',
        params: data
      });
    },
    SAVE_AGENCYPROMOTION: function SAVE_AGENCYPROMOTION() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/agencyPromotion/save',
        method: 'post',
        data: data
      });
    },
    UPDATE_AGENCYPROMOTION: function UPDATE_AGENCYPROMOTION() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/agencyPromotion/update',
        method: 'put',
        data: data
      });
    },
    UPDATE_AGENCYPROMOTION_STS: function UPDATE_AGENCYPROMOTION_STS() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/agencyPromotion/updateSts',
        method: 'put',
        data: data
      });
    },
    DELETE_AGENCYPROMOTION: function DELETE_AGENCYPROMOTION() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/agencyPromotion/delete',
        method: 'delete',
        data: data
      });
    },
    DELETE_BATCH_AGENCYPROMOTION: function DELETE_BATCH_AGENCYPROMOTION() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/agencyPromotion/deleteBatch',
        method: 'delete',
        data: data
      });
    },
    UPDATE_AGENCYPROMOTION_PASSWORD: function UPDATE_AGENCYPROMOTION_PASSWORD() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/agencyPromotion/updatePassWord',
        method: 'put',
        data: data
      });
    },
    get_MyRecommendation_Page_List: function get_MyRecommendation_Page_List() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/agencyPromotion/getMyRecommendationPageList',
        method: 'post',
        data: data
      });
    },
    convertPromotionAgency: function convertPromotionAgency() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/agencyPromotion/convertPromotionAgency',
        method: 'post',
        data: data
      });
    }
  };
});